/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';
import type User from 'flarum/common/models/User';
import type Article from 'flarum/orell-articles/models/Article';

/**
 * Serialized as a JSON-encoded PHP array keyed by integer status IDs, so the keys arrive as strings.
 */
export interface PerStatusCount {
	[statusId: string]: number;
}

export default class Bookshelf extends Model {
	name() {
		return Model.attribute<string>('name').call(this);
	}
	slug() {
		return Model.attribute<string>('slug').call(this);
	}

	isPrivate() {
		return Model.attribute<boolean>('isPrivate').call(this);
	}

	articleCount() {
		return Model.attribute<number>('articleCount').call(this);
	}

	position() {
		return Model.attribute<number | null>('position').call(this);
	}

	user() {
		return Model.hasOne<User>('user').call(this);
	}

	articles() {
		return Model.hasMany<Article>('articles').call(this);
	}

	coverArticles() {
		return Model.hasMany<Article>('coverArticles').call(this);
	}

	canEdit() {
		return Model.attribute<boolean>('canEdit').call(this);
	}

	/** Only serialized when non-zero. */
	recentActivityCount() {
		return Model.attribute<number | undefined>('recentActivityCount').call(this);
	}

	perStatusCount() {
		return Model.attribute<PerStatusCount, string>('perStatusCount', JSON.parse).call(this);
	}
}
